import { Link } from "react-router-dom";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import Carousel from "../ui/Carousel";
import userImage from "../../images/default-user-image.png";

const PeopleList = ({ actors = [], title = "عوامل" }) => {
  if (actors.length === 0) return null;

  return (
    <>
      <h3 className="mx-4 mt-[4rem] text-xl font-semibold leading-9">
        {title}
      </h3>
      <div className="my-6 w-full px-6">
        <Carousel
          step={200}
          arrowClassName="h-full"
          renderNext={() => <FiChevronRight size={45} />}
          renderPrev={() => <FiChevronLeft size={45} />}
        >
          {actors.map((actor, index) => (
            <div
              key={`${actor.actor_id ?? actor.id}-${index}`}
              className="inline-block h-[200px] align-top"
            >
              <Link to={`/Actor/${actor?.actor_id ?? actor?.id}`}>
                <div className="mr-4 flex flex-col items-center">
                  <img
                    className="h-[130px] w-[130px] rounded-full object-cover"
                    src={actor.image || userImage}
                    alt={actor.name}
                    loading="lazy"
                  />
                  <span className="mt-3 text-sm font-semibold leading-5 text-white">
                    {actor.name}
                  </span>
                  <span className="mt-3 text-sm font-semibold leading-5 text-white">
                    {actor.role}
                  </span>
                </div>
              </Link>
            </div>
          ))}
        </Carousel>
      </div>
    </>
  );
};

export default PeopleList;
